
export default function addPrefix(prefix, dict) {
    const prefixed = Object.keys(dict).reduce((acc, key) => {
        return { 
            ...acc,
            [`${prefix}::${key}`]: dict[key]
        }
    }, {}) 
    return prefixed
}